import React from "react";

/**
 * Orange "shifted" banner shown when today's unlock has been pushed to a
 * later time. Extracted verbatim from the monolith (`art_of_the_day-v2.tsx`
 * lines 1404–1430).
 */
export const AotdShiftBanner: React.FC<{ scheduledTime: string }> = ({ scheduledTime }) => {
  const scheduledDate = new Date(scheduledTime);
  const formattedUTC =
    scheduledDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    }) + " UTC";
  const localTimeString = scheduledDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });

  return (
    <div
      style={{
        border: "4px solid",
        padding: "10px 15px",
        backgroundColor: "transparent",
        marginBottom: "16px",
        textAlign: "center",
        fontWeight: 700,
        fontSize: "1.1rem",
        animation: "shiftGlow 1.8s ease-in-out infinite",
      }}
    >
      <style>{`
        @keyframes shiftGlow {
          0%, 100% { box-shadow: 0px 0px 10px 2px rgba(99, 102, 241, 0.6), 5px 10px rgba(0, 0, 0, 0.7); }
          50% { box-shadow: 0px 0px 11px 4px rgba(99, 102, 241, 0.9), 5px 10px rgba(0, 0, 0, 0.7); }
        }
      `}</style>
      <div style={{ marginBottom: "6px", letterSpacing: "0.5px" }}>
        ⏰ today&apos;s AOTD is shifted
      </div>
      <div style={{ fontSize: "1.05rem", fontWeight: 900 }}>
        available at <strong>{localTimeString}</strong>
      </div>
      <div style={{ fontSize: "0.8rem", fontWeight: 400, marginTop: "4px", opacity: 0.7 }}>
        ({formattedUTC})
      </div>
    </div>
  );
};

export default AotdShiftBanner;
